import React from 'react'
import { Modal, Dropdown, Menu, Button, Tabs } from 'antd'
import { DeleteOutlined, EditOutlined, FrownOutlined, SafetyOutlined, SmileOutlined, UserOutlined, KeyOutlined } from '@ant-design/icons'
import { connect } from 'react-redux'
import Form from './Form'
import UserPermissions from './Components/UserPermissions'
import { PERMISSIONS } from '../../Evolve/Utilities/permissions'

import ResetPassword from '../ResetPassword'

type Props = {
  subcontractors: [],
  id: ?any,
  type: string,
  deactivated: boolean,
  submitting: boolean,
  resetPasswordModal: {},
  userPermissions: [],
  componentWillMount: (props: any) => void,
  onClickSubmit: () => void,
  onClickCancel: () => void,
  onClickDelete: () => void,
  onClickReset: () => void,
  onClickRequireReset: () => void,
  onClickDeactivate: () => void,
  onClickReactivate: () => void,
  onCloseResetPasswordModal: () => void,
}

class UserModal extends React.PureComponent<Props> {

  constructor(props) {
    super(props)
    this.state = {
      permissionChanges: {},
      hasPermissionChanges: false,
      savePermissionsFunction: null
    }
  }

  componentWillMount = () => this.props.componentWillMount(this.props)

  handlePermissionChanges = (changes, hasChanges, saveFunction) => {
    this.setState({
      permissionChanges: changes,
      hasPermissionChanges: hasChanges,
      savePermissionsFunction: saveFunction
    })
  }

  handleSave = async () => {
    const { onClickSubmit } = this.props
    const { hasPermissionChanges, savePermissionsFunction } = this.state

    // If there are permission changes, save them first
    if (hasPermissionChanges && savePermissionsFunction) {
      const result = await savePermissionsFunction(false) // Don't show messages, we'll handle that in the main save
      if (!result.success) {
        // Permission save failed, don't proceed with user save
        return
      }
    }

    // Proceed with the normal user save
    onClickSubmit()
  }

  getOptionsMenuItems = () => {
    const {
      deactivated,
      onClickDelete,
      onClickReset,
      onClickRequireReset,
      onClickDeactivate,
      onClickReactivate,
    } = this.props

    const items = [
      {
        key: 'reset-password',
        label: <span><EditOutlined /> Reset Password</span>,
        onClick: onClickReset
      },
      {
        key: 'require-reset',
        label: <span><SafetyOutlined /> Require Password Reset</span>,
        onClick: onClickRequireReset
      }
    ]

    if (deactivated) {
      items.push({
        key: 'reactivate',
        label: <span><SmileOutlined /> Reactivate</span>,
        onClick: onClickReactivate
      })
    } else {
      items.push({
        key: 'deactivate',
        label: <span><FrownOutlined /> Deactivate</span>,
        onClick: onClickDeactivate
      })
    }

    items.push({
      key: 'delete',
      label: <span><DeleteOutlined /> Delete</span>,
      onClick: onClickDelete
    })

    return items
  }

  getOptionsMenu = () => {
    const {
      deactivated,
      onClickDelete,
      onClickReset,
      onClickRequireReset,
      onClickDeactivate,
      onClickReactivate,
    } = this.props
    return (
      <Menu
        onClick={({ key }) => {
          if (key === 'reset-password') {
            onClickReset()
          }
          if (key === 'require-reset') {
            onClickRequireReset()
          }
          if (key === 'deactivate') {
            onClickDeactivate()
          }
          if (key === 'reactivate') {
            onClickReactivate()
          }
          if (key === 'delete') {
            onClickDelete()
          }
        }}
      >
        <Menu.Item key='reset-password'><EditOutlined />{` Reset Password`}</Menu.Item>
        <Menu.Item key='require-reset'><SafetyOutlined />{` Require Password Reset`}</Menu.Item>
        {deactivated && (
          <Menu.Item key='reactivate'><SmileOutlined />{` Reactivate`}</Menu.Item>
        )}
        {!deactivated && (
          <Menu.Item key='deactivate'><FrownOutlined />{` Deactivate`}</Menu.Item>
        )}
        <Menu.Item key='delete'><DeleteOutlined />{` Delete`}</Menu.Item>
      </Menu>
    )
  }

  render() {

    const {
      subcontractors,
      id,
      type,
      submitting,
      resetPasswordModal,
      userPermissions,
      onClickSubmit,
      onClickCancel,
      onCloseResetPasswordModal,
    } = this.props

    const footer = []

    if (id) {
      footer.push([
        <Dropdown key='options' menu={{ items: this.getOptionsMenuItems() }}>
          <Button style={{ float: 'left' }} loading={submitting}>
            Options
          </Button>
        </Dropdown>,
      ])
    }

    footer.push([
      <Button key='cancel' disabled={submitting} onClick={onClickCancel}>
        Cancel
      </Button>,
      <Button key='save' type='primary' loading={submitting} onClick={this.handleSave}>
        Save
      </Button>,
    ])
console.log(PERMISSIONS);
console.log(userPermissions);
    return (

      <Modal
        title={id ? 'Edit User' : 'New User'}
        footer={footer}
        onCancel={onClickCancel}
        open
        width={id ? 1000 : 600}
      >

        {id ? (
          <Tabs
            defaultActiveKey="details"
            type="card"
            items={[
              {
                key: 'details',
                label: <span><UserOutlined />User Details</span>,
                children: (
                  <Form
                    subcontractors={subcontractors}
                    id={id}
                    type={type}
                    submitting={submitting}
                  />
                )
              },
              // Only show Permissions tab if user has permission to manage users
              ...(userPermissions.includes(PERMISSIONS.ALLOW_USER_ADMIN) ? [{
                key: 'permissions',
                label: <span><KeyOutlined />Permissions</span>,
                children: (
                  <UserPermissions
                    userId={id}
                    userType={type}
                    onGetPendingChanges={this.handlePermissionChanges}
                    onPermissionsChange={(permissions) => {
                      // Optional: Handle permission changes if needed
                      console.log('User permissions updated:', permissions)
                    }}
                  />
                )
              }] : [])
            ]}
          />
        ) : (
          <Form
            subcontractors={subcontractors}
            id={id}
            type={type}
            submitting={submitting}
          />
        )}

        {resetPasswordModal.show && (
          <ResetPassword
            id={id}
            onClose={onCloseResetPasswordModal}
          />
        )}

      </Modal>

    )

  }

}

const mapStateToProps = (state) => ({
  userPermissions: (state.user && state.user.permissions) || [],
})

export default connect(mapStateToProps)(UserModal)
